export default __webpack_public_path__ + "static/media/3009.7c18490d.jpg";